module.exports = __webpack_public_path__ + "img/caret-right-square-fill.43424e9d.svg";